// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__JAWl8","topBottomGutter":"Layout_topBottomGutter__2T4E6"};